export default __webpack_public_path__ + "static/media/cancion-triste-1502.b93823a1.mp3";